module.exports = __webpack_public_path__ + "img/close_circle.cc515da3.svg";